<script setup>
import combinationStorage from '@/services/combination-storage';
import { defineOptions, onMounted, reactive } from 'vue';

defineOptions({
  name: 'ModalBodyButtons'
});

const state = reactive({
  items: [],
});

onMounted(() => {
  loadItems();
});

async function loadItems() {
  const connectorProductIds = [];

  if (combinationStorage.categoryType === 'connector') {
    connectorProductIds.push(combinationStorage.productId);
  }

  if (
    combinationStorage.categoryType === 'cable'
  ) {
    if (combinationStorage.initialItem) {
      connectorProductIds.push(combinationStorage.initialItem.productId);
    }

    if (combinationStorage.terminalItem) {
      connectorProductIds.push(combinationStorage.terminalItem.productId);
    }
  }

  const res = await u.$http.get(
    '@combination_ajax/loadCategoryList',
    {
      params: {
        combinationShowIn: combinationStorage.categoryType,
        mappingIds: combinationStorage.mappingIds,
        level: 1,
        connectorProductIds: connectorProductIds,
        getMappingConnector: combinationStorage.getMappingConnector ? 1 : 0,
      }
    }
  );

  state.items = res.data.data.items;
}
</script>

<template>
  <div class="modal-body d-flex flex-column justify-content-center align-items-center">
    <h3 class="text-center">選擇產品分類</h3>
    <div class="w-100 row justify-content-center">
      <div v-for="item in state.items" class="col-12 col-md-5 mb-4">
        <button class="btn btn-dark w-100" @click="combinationStorage.goToCategoryList(item.path)">
          {{ item.title }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-dark {
  min-height: 100px;
  font-size: 24px;

  @media screen and (max-width: 767px) {
    min-height: 80px;
  }
}
</style>
